import { FormControlLabel, Switch } from '@mui/material';
import { FilterKeys, GetProductsQueryFilters } from '@schooly/api';
import {
  FilterDropdown,
  FiltersContainer,
  SchoolYearExpandedSelect,
  SchoolYearTagSelect,
} from '@schooly/components/filters';
import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { useIntl } from 'react-intl';

type ProductFiltersProps = {
  defaultShowAllFrequencies: boolean;
  filters: GetProductsQueryFilters;
  defaultFilters: GetProductsQueryFilters;
  onSetShowAllFrequencies: Dispatch<SetStateAction<boolean>>;
  showAllFrequencies: boolean;
  showFrequenciesToggle: boolean;
  onSetFilters: (v: GetProductsQueryFilters) => void;
};

export const ProductFilters: FC<ProductFiltersProps> = ({
  defaultShowAllFrequencies,
  filters,
  defaultFilters,
  onSetShowAllFrequencies,
  showAllFrequencies,
  showFrequenciesToggle,
  onSetFilters,
}) => {
  const { formatMessage } = useIntl();
  const { onSelectSchoolYear } = useMemo(() => {
    return {
      onSelectSchoolYear: (id: string) =>
        onSetFilters({
          ...filters,
          [FilterKeys.YearId]: [id],
        }),
    };
  }, [filters, onSetFilters]);

  const filtersSchoolYear = filters[FilterKeys.YearId];

  const schoolYearLabel = formatMessage({ id: 'schoolYear' });

  const selectedSchoolYear = filtersSchoolYear?.[0];

  return (
    <FiltersContainer>
      {selectedSchoolYear && (
        <FilterDropdown
          width={500}
          label={schoolYearLabel}
          tags={(open) => [
            <SchoolYearTagSelect
              key={selectedSchoolYear}
              sx={{ maxWidth: 200 }}
              id={selectedSchoolYear}
              onClick={open}
            />,
          ]}
        >
          {(onClose) => (
            <SchoolYearExpandedSelect
              selectedId={selectedSchoolYear}
              onSelect={onSelectSchoolYear}
              onClose={onClose}
            />
          )}
        </FilterDropdown>
      )}
      {showFrequenciesToggle && (
        <FormControlLabel
          sx={{
            px: 1.5,
          }}
          control={
            <Switch
              checked={showAllFrequencies}
              onChange={() => onSetShowAllFrequencies(!showAllFrequencies)}
            />
          }
          label={formatMessage({ id: 'frequencies-ShowDisabledFrequencies' })}
        />
      )}
    </FiltersContainer>
  );
};
